<template>
  <div class="chapters__list">
    <template v-if="isLoading">
      <div class="d-flex flex-column justify-content-center text-center align-items-center app__loading">
        <p><strong>Loading data...</strong></p>
        <b-spinner></b-spinner>
      </div>
    </template>
    <template v-else>
      <draggable
        v-model="chapters"
        v-bind="chaptersDragOptions"
        handle=".chapter__drag-handle"
        @start="isDragging = true"
        @end="isDragging = false"
        @change="chaptersOrderChange($event)"
      >
        <transition-group type="transition" :name="!isDragging ? 'flip-list' : null">
          <MonitorChapter
            v-for="(chapter, index) in chapters"
            :chapter="chapter"
            :key="chapter.id"
            :index="index"
            @requestChapterEdit="requestChapterEdit(chapter)"
            @requestChapterDelete="requestChapterDelete(chapter)"
            @requestChapterPublish="requestChapterPublish(chapter)"
            @chapterDuplicated="getChapters()"
          />
        </transition-group>
      </draggable>
    </template>

    <b-modal
      id="bv-modal-delete-chapter"
      size="lg"
      centered
      @ok="deleteChapter"
    >
      <template v-slot:modal-title>
        Move to Trash
      </template>
      <p>Are you sure you want to move {{ chapterToDelete.name }} chapter to the trash?</p>
      <b-alert variant="warning" show>
        <strong>WARNING: This action will update and delete this object also in the User Dashboard.</strong><br>
        Are you sure you want to proceed?
      </b-alert>
    </b-modal>

    <b-modal
      id="bv-modal-publish-chapter"
      size="lg"
      centered
      @ok="publishChapter"
    >
      <template v-slot:modal-title>
        Publish
      </template>
      Are you sure you want to publish {{ chapterToPublish.name }} chapter?
    </b-modal>

  </div>
</template>

<script>
import { mapGetters } from "vuex";
import draggable from "vuedraggable";

import MonitorChapter from "./MonitorChapter";

import {
  MONITOR_CHAPTER_GET_ALL,
  MONITOR_CHAPTER_EDIT,
  MONITOR_CHAPTER_DELETE,
  MONITOR_CHAPTER_PUBLISH
} from "@/store/actions.type";

import {
  STATE_MONITORS_CURRENT_CHAPTER_SET,
  STATE_MONITORS_STRUCTURE_CHAPTERS_ORDER_SET
} from "@/store/mutations.type";

export default {
  name: 'MonitorChapterList',
  props: ['updateList', 'monitorId'],
  components: {
    draggable,
    MonitorChapter
  },
  data() {
    return {
      isLoading: true,
      isDragging: false,
      chapters: {},
      chapterToDelete: {},
      chapterToPublish: {}
    }
  },
  computed: {
    ...mapGetters(["monitorTags", "monitorCurrent"]),
    chaptersDragOptions() {
      return {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "chapter__drag-ghost"
      };
    }
  },
  methods: {
    async getChapters() {
      await this.$store.dispatch(MONITOR_CHAPTER_GET_ALL, this.monitorId).then((data) => {
        this.chapters = data;
        this.returnChapters();
      });
      this.isLoading = false;
    },
    chapterStatusClasses(chapter) {
      return {
        'chapter__status': true,
        'chapter__status--draft': chapter.is_online === false,
        'chapter__status--empty': chapter.number_of_objects === 0, 
        'chapter__status--published': chapter.is_online === true
      }
    },
    returnChapters() {
      this.$emit('chaptersFetched', this.chapters);
    },
    chaptersOrderChange(event) {
      let newOrder = parseInt(event.moved.newIndex) + 1;
      let chapterId = event.moved.element.id;

      let chapterData = new FormData();
      chapterData.set('name', event.moved.element.name)
      chapterData.set('order', newOrder);

      let payload = {
        monitorId: this.monitorCurrent.monitor.id,
        chapterId: chapterId,
        chapterData: chapterData
      }

      this.$store.dispatch(MONITOR_CHAPTER_EDIT, payload).then(() => {
        this.$bvToast.toast(`Chapters order has been updated successfully`, {
          title: 'Chapters update',
          toaster: 'b-toaster-bottom-right',
          autoHideDelay: 4000,
          variant: 'primary'
        });
        this.isLoading = false;
        this.getChapters();
        this.$store.commit(STATE_MONITORS_STRUCTURE_CHAPTERS_ORDER_SET, this.chapters);
      });
    },
    requestChapterEdit(chapter) {
      this.$emit('requestChapterEdit', chapter);
    },
    requestChapterDelete(chapter) {
      this.chapterToDelete =  Object.assign({}, chapter);
      this.$bvModal.show('bv-modal-delete-chapter');
    },
    deleteChapter() {
      this.isLoading = true;
      let payload = {
        monitorId: this.monitorId,
        chapterId: this.chapterToDelete.id
      }
      this.$store.dispatch(MONITOR_CHAPTER_DELETE, payload).then(() => {
        this.$bvToast.toast(`Chapter ${this.chapterToDelete.name} has been deleted successfully`, {
          title: 'Chapter deleted',
          toaster: 'b-toaster-bottom-right',
          autoHideDelay: 4000,
          variant: 'primary'
        });
        this.chapterToDelete = {};
        this.getChapters();
        this.isLoading = false;
      });
    },
    requestChapterPublish(chapter) {
      this.chapterToPublish = Object.assign({}, chapter);
      this.$bvModal.show('bv-modal-publish-chapter');
    },
    publishChapter() {
      // let chapterData = new FormData();
      // chapterData.set('monitor_id', this.monitorCurrent.monitor.id);
      // chapterData.append('chapter_ids', this.chapterToPublish.id);
      // chapterData.append('published', true);

      // let payload = {
      //   monitorId: this.chapterToPublish.monitor,
      //   chapterId: this.chapterToPublish.id,
      //   chapterData: chapterData
      // }

      let chapterData = new FormData();
      chapterData.append('chapter_id', this.chapterToPublish.id);

      this.$store.dispatch(MONITOR_CHAPTER_PUBLISH, chapterData).then(() => {
      // this.$store.dispatch(MONITOR_CHAPTER_EDIT, payload).then(() => {
        this.$bvToast.toast(`Chapter ${this.chapterToPublish.name} has been published`, {
          title: 'Chapter published',
          toaster: 'b-toaster-bottom-right',
          autoHideDelay: 4000,
          variant: 'primary'
        });
        this.getChapters();
      });
    },
    setCurrentChapter(chapter) {
      this.$store.commit(STATE_MONITORS_CURRENT_CHAPTER_SET, chapter);
    },
  },
  mounted() {
    // this.getChapters();
  },
  watch: { 
    monitorId: function() {
      this.getChapters();
    },
    updateList: function(newValue) {
      if(newValue === true) {
        this.getChapters();
      }
    },
    chapters: function() {
      // simuliamo fetch anche se è solo un reorder
      this.$emit('chaptersFetched', this.chapters);
    }
  }
}
</script>

<style lang="scss">

</style>